import React, { useState } from 'react'
import { CCard, CCardBody, CCardHeader, CFormInput, CCol, CRow, CButton, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CFormLabel } from '@coreui/react'
import { DataGrid } from '@mui/x-data-grid'
import { Link, useLoaderData, useLocation } from 'react-router-dom'
import AxiosInstance from 'src/components/Axios'
import { cilPen, cilPlus, cilTrash } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { useEffect } from 'react'
import { confirmAlert } from 'react-confirm-alert'
import AsyncSelect from 'react-select/async'
// import { Select } from '@mui/material'
import Select from 'react-select';
import { useConvertToLocalTime } from 'src/components/store/useConvertToLocalTime'
import dayjs from 'dayjs';

const page = 1
// const urlApi = '/jobs'
const urlApi = '/job_tools'
const urlRouter = '/jobs'

// хто увійшов
const role = localStorage.getItem('user_role')
// console.log(role)

// дані користувача
const userData = JSON.parse(localStorage.getItem('user_data'))
const tokenStr = localStorage.getItem('user')
const header = { headers: { Authorization: `Bearer ${tokenStr}`, accept: 'application/json' } }
const utcNow = dayjs().toISOString()

// перше завантаження
export async function LoaderJobTools({ params }) {
   let query = `page=${page}`
   const request = `account.user.id=${userData.id}`

   // запит тільки даних користувача
   if (role === 'ROLE_ADMIN') {
      // console.log('запит адмін')
      let res = await AxiosInstance.get(`${urlApi}?${query}`).then((response) => {
         return response
      })
      return res
   } else {
      // console.log('запит партнера')
      let res = await AxiosInstance.get(`${urlApi}?${query}&${request}`).then((response) => {
         return response
      })
      return res
   }
   // if (Array.isArray(res.data)) {
   //   res.data.sort((a, b) => dayjs(b.dateModified).valueOf() - dayjs(a.dateModified).valueOf());
   // }


}

// головний контент
const JobTools = () => {
   const { data } = useLoaderData()
   console.log('data Jobs', data)
   const { state } = useLocation();
   // console.log('state1', state);
   //закоментовано для таблиці інструментів =================2
   // const [rows, setRows] = useState(false)
   const [rows, setRows] = useState([])

   const [rowCountState, setRowCountState] = useState(0)
   // для пошуку
   const [nameFilterSearch, setNameFilterSearch] = useState('')
   const [partnerFilterSearch, setPartnerFilterSearch] = useState('')
   const [statusFilterSearch, setStatusFilterSearch] = useState('')
   const [factoryFilterSearch, setFactoryFilterSearch] = useState('')
   const [dateEnteredAfterFilterSearch, setDateEnteredAfterFilterSearch] = useState('')
   const [dateEnteredBeforeFilterSearch, setDateEnteredBeforeFilterSearch] = useState('')
   const [showLoader, setShowLoader] = useState(false)

   // Заблокувати кнопку фільрації якщо не введені символи для пошуку
   const [disabled, setDisabled] = useState(true)


   // Список можливих статусів
   const optionsStatus = [
      { value: 'send-to-verify', label: 'На перевірці' },
      { value: 'rejected', label: 'Відмовлено' },
      { value: 'verified', label: 'Підтверджено' },
      // { value: 'synced', label: '1С' },
   ];

   // Якщо лінк відбувся з головної сторінки по "not_checked", то віддразу відфільтрувати
   // useEffect(() => {
   //    // console.log('state', state);
   //    // console.log("фільтр по статус");
   //    if (state?.status === "not_checked") {
   //       // Задати значення "Статус" в фільтрі для коректного відображення активного фільтра
   //       setStatusFilterSearch({ value: 'not_checked', label: 'Не перевірено' });
   //       AxiosInstance.get(`${urlApi}?status=${state.status}`).then((response) => {
   //          //Сортування по полю dateModified
   //          const sorted = [...response.data['hydra:member']].sort((a, b) => {
   //             const aDate = a.dateModified ? dayjs(a.dateModified).valueOf() : 0
   //             const bDate = b.dateModified ? dayjs(b.dateModified).valueOf() : 0
   //             return bDate - aDate
   //          })

   //          setRows(sorted)
   //          setRowCountState(response.data['hydra:totalItems'])
   //          //Сортування по полю dateModified
   //          // setRows(response.data['hydra:member']);
   //          // setRowCountState(response.data['hydra:totalItems']);
   //       });
   //    }
   // }, [state]);

   // перевірка чи є масив даних
   // if (!rows) {
   //   setRows(data['hydra:member']) //масив
   //   setRowCountState(data['hydra:totalItems']) //кількість
   // }

   //Закоментовано для таблиці інструментів (1=========================)
   //Сортування по dateModified при першому заповненні
   // if (!rows) {
   //    const sorted = [...data['hydra:member']].sort((a, b) => {
   //       const aDate = a.dateModified ? dayjs(a.dateModified).valueOf() : 0
   //       const bDate = b.dateModified ? dayjs(b.dateModified).valueOf() : 0
   //       return bDate - aDate
   //    })

   //    setRows(sorted)
   //    setRowCountState(data['hydra:totalItems'])
   // }


   // Фільтр
   const getRowsTable = (p = 1) => {
      setShowLoader(true)
      let request = ``
      // перевірка чи є щось в імені
      // if (nameFilterSearch !== '') {
      //    request += `&name=${nameFilterSearch}`
      //    if (role === 'ROLE_ADMIN') request += `&name=${nameFilterSearch}`
      //    if (role === 'ROLE_PARTNER') request += `&accountWorkers.account.${nameFilterSearch}`
      // }
      if (nameFilterSearch !== '') {
         request += `&jobToolList.name=${nameFilterSearch}`
      }

      // якщо вибрананий контрагент

      // if (partnerFilterSearch !== '') request += `&account.name=${partnerFilterSearch.label}`  //
      if (partnerFilterSearch !== '') request += `&job.account.id=${partnerFilterSearch.value}`
      if (statusFilterSearch !== '') request += `&status=${statusFilterSearch?.value}`
      if (factoryFilterSearch !== '') request += `&job.factory.id=${factoryFilterSearch.value}`
      // if (dateEnteredAfterFilterSearch !== '') request += `&dateEntered[after]=${dateEnteredAfterFilterSearch}` // не включно
      // if (dateEnteredAfterFilterSearch !== '') request += `&dateEntered[strictly_after]=${dateEnteredAfterFilterSearch}` // включно
      if (dateEnteredAfterFilterSearch !== '') request += `&job.dateEnd[strictly_after]=${dateEnteredAfterFilterSearch}`

      // if (dateEnteredBeforeFilterSearch !== '') request += `&dateEntered[before]=${dateEnteredBeforeFilterSearch}` // не включно
      // if (dateEnteredBeforeFilterSearch !== '') request += `&dateEntered[strictly_before]=${dateEnteredBeforeFilterSearch}` // не включно (хіба додатково ввести час)
      if (dateEnteredBeforeFilterSearch !== '') request += `&job.dateStart[strictly_before]=${dateEnteredBeforeFilterSearch}`
      // відображаємо тільки з даних користувача
      if (role === 'ROLE_PARTNER') {
         request += `&user.id=${userData.id}`
         // request += `&account.user.id=${userData.id}`
      }

      // запит після пошуку
      AxiosInstance.get(`${urlApi}?page=${p}${request}`).then((response) => {
         setRows(response.data['hydra:member'])
         setRowCountState(response.data['hydra:totalItems'])
         setShowLoader(false)
      })
   }

   // зміна сторінки
   const handlePageChange = (page) => {
      getRowsTable(page + 1)
   }

   // Заблокувати кнопку фільтрації, якщо не введені символи для пошуку
   const disabledButton = () => {
      setDisabled(
         typeof partnerFilterSearch === 'string' &&
         partnerFilterSearch.trim() === '' &&
         nameFilterSearch.trim() === '' &&
         statusFilterSearch === '' &&
         factoryFilterSearch === '' &&
         dateEnteredAfterFilterSearch === '' &&
         dateEnteredBeforeFilterSearch === ''
      );
   };

   // Розблокувати кнопку, якщо хоча б одне поле містить значення
   useEffect(() => {
      disabledButton()
   }, [nameFilterSearch, partnerFilterSearch, statusFilterSearch, factoryFilterSearch, dateEnteredAfterFilterSearch, dateEnteredBeforeFilterSearch])

   // зміна стейту пошуку "Назва"
   const handleNameFilterChange = (e) => {
      setNameFilterSearch(e.target.value)
      disabledButton(e)
   }

   // Фільтрування
   const handleFilterSearch = () => {
      getRowsTable()
   }

   // Скинути фільтр і показати весь список
   const handleFilterReset = () => {
      setNameFilterSearch('')
      setPartnerFilterSearch('')
      // setStatusFilterSearch('')
      setStatusFilterSearch('')
      setFactoryFilterSearch('')
      setDateEnteredAfterFilterSearch('')
      setDateEnteredBeforeFilterSearch('')
      setDisabled(true)


      setRows([])
      // setTimeout(() => {
      //    getRowsTable()
      // }, 200)
   }
   //Ефект для очищення фільтра.Закоментовано для списку інструментів
   // useEffect(() => {
   //    if (
   //       nameFilterSearch === '' &&
   //       partnerFilterSearch === '' &&
   //       statusFilterSearch === '' &&
   //       factoryFilterSearch === '' &&
   //       dateEnteredAfterFilterSearch === '' &&
   //       dateEnteredBeforeFilterSearch === ''
   //    ) {
   //       getRowsTable()
   //    }
   // }, [
   //    nameFilterSearch,
   //    partnerFilterSearch,
   //    statusFilterSearch,
   //    factoryFilterSearch,
   //    dateEnteredAfterFilterSearch,
   //    dateEnteredBeforeFilterSearch,
   // ])


   async function deleted(row) {
      try {
         await confirmAlert({
            title: 'Ви впевнені що хочите видалити цей пункт ?',
            message: 'Are you sure to do this.',
            buttons: [
               {
                  label: 'Так',
                  onClick: async () => {
                     const response = await AxiosInstance.delete(`${urlApi}/${row.id}`)

                     console.log('Пункт успішно видалено.', response)

                     getRowsTable()
                  },
               },
               {
                  label: 'Ні',
                  onClick: () => {
                     return
                  },
               },
            ],
         })
      } catch (error) {
         console.error('Помилка видалення:', error)
      }
   }

   // Дані, які навнюються в таблицю
   const columns = [
      { field: 'id', headerName: 'ID', width: 50 },
      // { field: 'code1c', headerName: 'code1c', width: 95 },
      {
         // field: 'dateEntered',
         field: 'params.row.job.dateStart',
         headerName: 'Дата початку',
         width: 150,
         renderCell: (params) => {
            return (
               <span>
                  {params.row?.job?.dateStart ? dayjs(params.row.job.dateStart).local().format('YYYY-MM-DD') : "❌"}
               </span>
            )
         },
      },
      {
         field: 'dateModified',
         headerName: 'Дата кінця',
         width: 150,
         renderCell: (params) => {
            return (
               <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  {params.row?.job?.dateEnd ? dayjs(params.row.job.dateEnd).local().format('YYYY-MM-DD') : "-"}
               </div>
            )
         },
      },
      {
         field: 'name',
         headerName: 'Назва',
         width: 150,
         renderCell: (params) => {
            return (
               <Link
                  to={`${urlRouter}/update/${params.row.id}`}
                  // style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}
                  style={{ textDecoration: 'none' }}
               >
                  {/* {params.row.name} */}
                  {params.row.jobToolList.name}
               </Link>
            )
         },
      },

      {
         field: 'params.row.job.name',
         headerName: 'Назва роботи',
         width: 200,
         renderCell: (params) => {
            return params.row.job?.name || "❌"
         }
      },
      { field: 'status', headerName: 'Статус', width: 110 },

      {
         field: 'factory',
         headerName: 'Підрозділ',
         width: 185,
         renderCell: (params) => {
            return (
               <span>
                  {params.row.job?.factory?.name ? params.row?.job?.factory.name : ""}
               </span>
            )
         },
      },
      {
         field: 'params.row.jobToolList.account.name',
         headerName: 'Контрагент',
         width: 380,
         renderCell: (params) => {
            return (
               // <></>
               params.row.jobToolList.account.name
            )
         },
      },
      {
         field: 'action',
         headerName: 'Action',
         width: 70,
         sortable: false,
         renderCell: (params) => {
            return (
               <Link to={`${urlRouter}/update/${params.row.job.id}`}>
                  <CButton color="dark" variant="outline">
                     <CIcon icon={cilPen} customClassName="nav-icon" height={20} />
                  </CButton>
               </Link>
            )
         },
      },

      // {
      //    field: 'delete',
      //    headerName: 'Видалити',
      //    width: 80,
      //    sortable: false,
      //    renderCell: (params) => {
      //       return (
      //          <CButton
      //             color="danger"
      //             variant="outline"
      //             onClick={() => {
      //                deleted(params.row)
      //             }}
      //          >
      //             <CIcon icon={cilTrash} customClassName="nav-icon" height={20} />
      //          </CButton>
      //       )
      //    },
      // },
   ]

   // Натиснення кнопки: "Enter" - виконати пошук; "Escape" - скинути пошук
   const keyDown = (event) => {
      // Виконати пошук
      if (event.key === 'Enter' && !disabled) {
         event.preventDefault()
         handleFilterSearch(event)
      }
      // Скинути пошук
      if (event.key === 'Escape') {
         event.preventDefault()
         handleFilterReset(event)
      }
   }



   // логіка запиту у фільтрації 

   const loadOptions = async (inputValue) => {
      if (role === 'ROLE_ADMIN') {
         return await AxiosInstance.get(`/accounts?name=${inputValue}`, header).then((response) => {
            console.log('response.data', response.data)
            return response.data.map((result) => ({
               label: result.name,
               value: result.id,
            }));
         });
      } else {
         if (userData.id) {
            return await AxiosInstance.get(`/accounts?user.id=${userData.id}&name=${inputValue}`, header).then((response) => {
               return response.data.map((result) => ({
                  label: result.name,
                  value: result.id,
               }));
            });
         }
      }
   }



   // Завантажити список підрозділів
   const loadOptionsFactory = async (inputValue) => {
      return await AxiosInstance.get(`/factories`, header).then((response) => {
         // console.log('response get /factories', response)
         return response.data.map((result) => ({
            label: result.name,
            value: result.id,
         }))
      })
   }

   // при зміні опції
   const handleChangePartner = (select) => {
      setPartnerFilterSearch(select)
   }
   // const [selectedOption, setSelectedOption] = useState(null);

   const handleChangeStatus = (select) => {
      setStatusFilterSearch(select)
   }

   // при зміні опції
   const handleChangeFactory = (select) => {
      setFactoryFilterSearch(select)
   }

   // const handleChange = (selectedOption) => {
   //   setSelectedOption(selectedOption);
   // };

   console.log('rows', rows)
   console.log('partnerFilterSearch', partnerFilterSearch)
   console.log('statusFilterSearch', statusFilterSearch)
   console.log('factoryFilterSearch', factoryFilterSearch)
   console.log('userData', userData)

   return (
      <CRow>
         <CCol xs={12}>
            <CCard className="mb-4">
               <CAccordion flush>
                  <CAccordionItem>
                     <CAccordionHeader onClick={loadOptions}>
                        <strong>Фільтр</strong>
                     </CAccordionHeader>
                     <CAccordionBody>
                        <CRow className="my-3 mx-2">
                           <CCol md={9} className="me-auto">
                              <CRow>
                                 <CCol md={3} className="filter-field">
                                    <CFormInput
                                       placeholder="Назва"
                                       id="nameFilterSearch"
                                       aria-label="Пошук"
                                       className="me-2"
                                       onChange={handleNameFilterChange}
                                       value={nameFilterSearch}
                                       onKeyDown={keyDown}
                                       autoComplete="off"
                                    />
                                 </CCol>

                                 <CCol md={3} className="filter-field">
                                    {/* <CFormLabel htmlFor="exampleFormControlInput1">Контрагент</CFormLabel> */}
                                    <AsyncSelect
                                       cacheOptions
                                       loadOptions={loadOptions}
                                       defaultOptions
                                       value={partnerFilterSearch}
                                       onChange={handleChangePartner}
                                       className="flex-grow-1"
                                       placeholder="Контрагент"
                                    />
                                 </CCol>

                                 <CCol md={3} className="filter-field">
                                    <Select
                                       options={optionsStatus}
                                       value={statusFilterSearch}
                                       onChange={handleChangeStatus}
                                       className="flex-grow-1"
                                       placeholder="Статус"
                                    />
                                 </CCol>

                                 <CCol md={3} className="filter-field">
                                    <AsyncSelect
                                       cacheOptions
                                       loadOptions={loadOptionsFactory}
                                       defaultOptions
                                       value={factoryFilterSearch}
                                       onChange={handleChangeFactory}
                                       className="flex-grow-1"
                                       placeholder="Підрозділ"
                                    />
                                 </CCol>

                                 <CCol md={4} className="filter-field">
                                    {/* <div className="mb-3"> */}
                                    <CFormLabel className="mt-3" htmlFor="exampleFormControlInput2">Дата створення (від, включно)</CFormLabel>
                                    <CFormInput
                                       type="date"
                                       id="exampleFormControlInput2"
                                       defaultValue="Дата створення (від)"
                                       value={dateEnteredAfterFilterSearch}
                                       onChange={(e) => setDateEnteredAfterFilterSearch(e.target.value)}
                                       autoComplete="off"
                                    />
                                    {/* </div> */}
                                 </CCol>

                                 <CCol md={4} className="filter-field">
                                    {/* <div className="mb-3"> */}
                                    <CFormLabel className="mt-3" htmlFor="exampleFormControlInput2">Дата створення (до, не включно)</CFormLabel>
                                    <CFormInput
                                       type="date"
                                       id="exampleFormControlInput2"
                                       defaultValue="Дата створення (до)"
                                       value={dateEnteredBeforeFilterSearch}
                                       onChange={(e) => setDateEnteredBeforeFilterSearch(e.target.value)}
                                       autoComplete="off"
                                    />
                                    {/* </div> */}
                                 </CCol>
                              </CRow>
                           </CCol>

                           <CCol md={3} style={{ textAlign: 'end' }}>
                              <CButton className="me-2" type="submit" color="secondary" onClick={handleFilterSearch} disabled={disabled}>Пошук</CButton>
                              <CButton type="submit" color="secondary" onClick={handleFilterReset}>X</CButton>
                           </CCol>
                        </CRow>
                     </CAccordionBody>
                  </CAccordionItem>
               </CAccordion>

               <CCardHeader>
                  <strong>Інструменти</strong> <small></small>
               </CCardHeader>
               <CCardBody>
                  <p className="text-medium-emphasis small">
                     {/* <Link to={`${urlRouter}/create`}>
                        <CButton color="secondary">
                           <CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                           Створити
                        </CButton>
                     </Link> */}
                  </p>
                  <div style={{ height: 400, width: '100%', }}>
                     <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={30}
                        rowsPerPageOptions={[30]}
                        pagination
                        rowCount={rowCountState}
                        paginationMode="server"
                        onPageChange={handlePageChange}
                        loading={showLoader}
                     />
                  </div>
               </CCardBody>
            </CCard>
         </CCol >
      </CRow >
   )
}

export default JobTools
